<template>
  <div class="site-view">
    <Header />
    <Modal v-if="modalOpen" :Selected="strategies.selected" />
    <!--Way forward section-->
    <section class="page-section banner page2-hero">
      <img
        src="@/assets/images/StIves/gifs/Runner.gif"
        class="full-width-image"
      />
      <!-- <video
        class="full-width-image webm-video"
        playsinline
        autoplay
        muted
        loop
      >
        <source
          type="video/webm"
          src="@/assets/images/StIves/videos/Runner.webm"
        />
      </video> -->
      <div class="container">
        <div class="row">
          <div class="col m12 l10">
            <div class="article">
              <h1>The Way Forward</h1>
              <hr class="header-underline main" />
              <p>
                Doing nothing is not an option. Increasing growth across
                Huntingdonshire makes it urgent to develop a better transport
                network for those who live and travel within the St Ives area.
                The Combined Authority is already working on plans to improve
                the A141 around Huntingdon – and now we must improve the St Ives
                transport network too.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col m12 l6">
              <p>
                The goal is to make a network that respects the heritage and
                environment but can also sustain growth for St Ives long into
                the future. It should address health and wellbeing, active
                travel, greener transport, carbon-reduction and the transport
                needs of those who live and work in the town.
              </p>
          </div>
        </div>
         <div class="row">
          <div class="col m12 l6">
              <p>
                So, an improvement scheme to tackle road congestion around St
                Ives is going to happen – but the actual option has yet to be
                decided. That is where your local knowledge comes in. The
                Combined Authority and partners will use your insights to help
                decide the best way forward for the St Ives study.
              </p>
          </div>
        </div>
      </div>
    </section>
    <!--Strategic option section-->
    <section class="page-section nav-section">
      <img
        src="@/assets/images/StIves/gifs/Scooter_Right.gif"
        class="right-side-image"
      />
      <!-- <video
        class="right-side-image webm-video"
        playsinline
        autoplay
        muted
        loop
      >
        <source
          type="video/webm"
          src="@/assets/images/StIves/videos/scooter.webm"
        />
      </video> -->
      <div class="container">
        <div class="article-nav">
          <h1>The Options</h1>
          <hr class="header-underline" />
          <p></p>
          <div class="navs">
            <div
              v-for="(strategy, index) in strategies.strats"
              :key="`strategies_navs_${index}`"
            >
              <h2
                v-if="index !== strategies.selected"
                @click="() => selectStrategy(index)"
              >
                {{ strategy.shortHeader }}
              </h2>
              <h2 v-if="index === strategies.selected" class="active">
                {{ strategy.shortHeader }}
              </h2>
            </div>
          </div>
          <div class="selects">
            <form>
              <select v-model="strategies.selected">
                <option
                  v-for="(strategy, index) in strategies.strats"
                  :key="`strategies_option_${index}`"
                  :value="index"
                >
                  {{ strategy.header }}
                </option>
              </select>
            </form>
          </div>
          <hr style="margin-bottom: 80px" />

          <div class="nav-content">
            <div class="row">
              <div class="col s12 l6">
                <div class="nav-text">
                  <h2>{{ strategies.strats[strategies.selected].header }}</h2>
                  <ul>
                    <li
                      v-for="(text, index) in strategies.strats[
                        strategies.selected
                      ].text"
                      :key="`strategies_text_${index}`"
                    >
                      {{ text }}
                      <ul
                        v-if="
                          strategies.strats[strategies.selected].subtext &&
                          index === 0
                        "
                      >
                        <li
                          v-for="(sub, j) in strategies.strats[
                            strategies.selected
                          ].subtext"
                          :key="`tab_${index}_subtext_${j}`"
                        >
                          {{ sub }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div>
                    <p
                      v-for="(p, index) in strategies.strats[
                        strategies.selected
                      ].additionalText"
                      :key="`strategies_additionaltext_${index}`"
                     v-html="p">
                     
                    </p>
                  </div>
                </div>
              </div>
              <div class="col s12 l6">
                <InnerImageZoom
                  :src="strategies.strats[strategies.selected].map"
                  :zoomSrc="strategies.strats[strategies.selected].map"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Policy section-->
    <section class="page-section darken">
      <div class="container">
        <h1>Wider Policy Objectives</h1>
        <hr class="header-underline" />
        <div class="card-space boxes">
          <div
            class="card"
            v-for="(policy, index) in policies"
            :key="`policy_boxes_${index}`"
          >
            <div
              :style="{
                backgroundImage:
                  'url(' +
                  require('@/assets/images/StIves/policy_icons/icon' +
                    (index + 1) +
                    '.png') +
                  ')',
              }"
            ></div>
            <div>
              <p>{{ policy }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section lake-house">
      <!-- <video
        class="right-side-image webm-video"
        playsinline
        autoplay
        muted
        loop
      >
        <source
          type="video/webm"
          src="@/assets/images/StIves/videos/plant.webm"
        />
      </video> -->
      <img
        src="@/assets/images/StIves/gifs/plant_Right.gif"
        class="right-side-image"
        style="width: 450px"
      />
      <div class="container">
        <div class="row">
          <div class="col m12 l7">
            <div class="article dark">
              <h1>The Goals</h1>
              <hr class="header-underline" />
              <p>St Ives improvements aim to;</p>
              <ul>
                <li>
                  Ensure sufficient highway capacity to accommodate transport
                  demand on the corridor from new growth sites in the region.
                </li>
                <li>Improve movement for public transport.</li>
                <li>
                  Improve connectivity and quality for walking and cycling by:
                  <ul>
                    <li>
                      Incorporating appropriate provision within the scheme.
                    </li>
                    <li>Enabling existing roads to support these modes.</li>
                  </ul>
                </li>
                <li>
                  Address current congestion and delay, cutting journey times
                  and improving reliability.
                </li>
                <li>Reduce ‘rat-running’ through St Ives town centre.</li>
              </ul>
            </div>
          </div>
          <div class="col s5"></div>
        </div>
      </div>
    </section>

    <!--Timeline Section-->
    <!--When screen width is medium-large-->
    <section
      class="page-section challenge swans"
      id="timeline-progress-section"
    >
      <!-- <video
        class="right-side-image webm-video"
        playsinline
        autoplay
        muted
        loop
      >
        <source
          type="video/webm"
          src="@/assets/images/StIves/videos/swans_gif-v2.webm"
        />
      </video> -->
      <img
        src="@/assets/images/StIves/gifs/swans_Right.gif"
        class="right-side-image"
        style="width: 1258px"
      />
      <div class="container" style="position: relative">
        <h1>St Ives Countdown</h1>
        <hr class="header-underline" />

        <div class="timeline">
          <div
            v-for="(date, index) in timeline.time"
            :key="`timeline_date_${index}`"
            class="timeline-point"
            @click="() => selectTimeline(index)"
          >
            <!--Inactive timeline image-->
            <!--Active timeline image-->
            <!--Inactive progress points-->
            <div v-if="index > timeline.selected" class="progress-point"></div>
            <!--Passed progress points-->
            <div
              v-if="index < timeline.selected"
              class="progress-point active"
            ></div>
            <!--Active progress points-->
            <div
              v-if="index === timeline.selected"
              class="progress-check active"
            >
              <i class="fas fa-check"></i>
            </div>
            <!--Inactive header-->
            <h2 v-if="index !== timeline.selected">{{ date.header }}</h2>
            <!--Active header-->
            <h2 v-if="index === timeline.selected" class="active">
              {{ date.header }}
            </h2>
          </div>
        </div>
        <div class="timeline-progress">
          <div class="bar"></div>
          <div id="timeline-fill" class="bar fill"></div>
        </div>
        <div class="section-card">
          <h2>
            <i class="fas fa-check"></i>
            {{ timeline.time[timeline.selected].header }}
          </h2>
          <p>
            {{ timeline.time[timeline.selected].text }}
          </p>
        </div>
      </div>
    </section>

    <!--Timeline Section-->
    <!--When screen width is medium-large-->
    <section class="page-section" id="timeline-cards-section">
      <div class="container">
        <h1>A141 Improvement Timeline</h1>
        <hr class="header-underline" />
        <div class="card-space boxes">
          <div
            class="card timeline-card"
            v-for="(date, index) in timeline.time"
            :key="`timeline_card_${index}`"
          >
            <div class="timeline-card-text">
              <h2>{{ date.header }}</h2>
              <p>{{ date.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section survey">
      <video class="full-image webm-video" playsinline autoplay muted loop>
        <source
          type="video/webm"
          src="@/assets/images/StIves/videos/cyclist.webm"
        />
      </video>
      <img
        src="@/assets/images/StIves/placeholder/St-Ives_Cyclist_150ppi.png"
        class="response-img"
      />
      <div class="container">
        <div class="row">
          <div class="col m12 l7">
            <div class="summary-card">
              <h1>Have Your Say!</h1>
              <hr class="header-underline" />
              <p>
                This is your St Ives, your future. Your opinion will shape the
                all-important decision on how and where we should improve the St
                Ives road network. Please now consider the options and tell us
                which you prefer.
              </p>
              <a href="/map/entity/gnzMtAZnfEwWjsUW3IHX/addentity/feedback"
                ><button class="link1">Have Your Say!</button></a
              >
            </div>
          </div>
          <div class="com m0 l5"></div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Header from "@/components/a141/Header";
import Footer from "@/components/customPages/components/footer";
import Modal from "@/components/customPages/components/MapModal";

import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
import InnerImageZoom from "vue-inner-image-zoom";

// var $ = require("jquery");
//import fancybox from "jquery-fancybox";

export default {
  name: "schemesPage",
  components: {
    Header,
    Footer,
    Modal,
    InnerImageZoom,
  },
  data() {
    return {
      modalOpen: false,
      policies: [
        "Support economic growth in St Ives by delivering a road network that works better for people, reduces existing congestion, improves journey times and boosts network capacity for all types of road user",
        "Improve access around St Ives to/from road and rail networks and to/from London for business, leisure, and tourism",
        "Extend the success of Greater Cambridge across the region",
        "Attract investment and well-paid employment to St Ives",
        "Maintain traffic at or below 2018 levels",
        "Cut vehicle mileage",
        "Improve capacity, reliability, and speed for public transport ",
        "Help reduce emissions to ‘net zero’ by 2050, to lessen the impact of transport and travel on climate change",
      ],
      strategies: {
        selected: 0,
        strats: [
          {
            shortHeader: "Option 1",
            header: "Option 1: Bypass Option",
            text: [],
            additionalText: [
              "This option consists of an offline bypass from the A141, around the north of St Ives, to the A1123 to the east of St Ives. ",
              "A new connection would be made between the A1123 and the A1096. The A1096 would be upgraded including its junction with Low Road.",
              "Bypass alignments are indicative and would avoid existing properties.",
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmaps1.png?alt=media&token=f6456ff3-1cdc-44f8-b7e9-9facebe795f7",
          },
          {
            shortHeader: "Option 2",
            header: "Option 2: Bypass Option",
            text: [],
            additionalText: [
              "This option consists of an offline bypass from the A141, around the north of St Ives, which connects with an upgraded Marley Road.",
              "Online upgrades in the form of junction and capacity improvements would be made to the B1040, A1123 and A1096 including the Low Road junction.",
              "Bypass alignments are indicative and would avoid existing properties.",
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmaps2.png?alt=media&token=c2c0c898-1e8f-49a2-bf3f-19678d8e36bb",
          },
          {
            shortHeader: "Option 3",
            header: "Option 3: Bypass Option",
            text: [],
            additionalText: [
              "This option consists of an offline bypass from the A141, around the north of St Ives, which connects with an upgraded Marley Road.",
              "From the B1040 an offline link would be provided to connect the B1040 with the A1123. ",
              "A new connection would be made between the A1123 and the A1096, and the A1096 upgraded including the Low Road junction.",
              "Bypass alignments are indicative and would avoid existing properties.",
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmap3.png?alt=media&token=c42221a0-2d76-4b15-bc06-a7e2e3712d1f",
          },
          {
            shortHeader: "Option 4",
            header: "Option 4: Local Junction Improvements",
            text: [],
            additionalText: [
              "<b>Junction Signal Improvements</b>",
              "Under option 4, to help improve traffic flow on the A1123, signal improvements would be made to the A1123/Hill Rise/High Leys junction and the A1123 Ramsey Road junction where possible.",
              "<b>Access Restrictions</b>",
              "To help reduce rat-running, access restrictions in the form of a ‘no-right turn’ restriction on vehicles turning into Needingworth Road from the A1123 west would be considered. ",
              "To help reduce rat-running, access restrictions would also be considered on the Meadow Lane approach to the A1096 roundabout to restrict vehicles entering the roundabout at this arm during peak times. Access would remain for vehicles accessing the Cattle Market Car Park. ",
              "<b>Junction Geometric Improvements</b>",
              "Geometric improvements would be considered to assist the movements of vehicles and increase capacity at the A1096/Low Road roundabout, the A1096/Meadow Lane roundabout, the A1123/B1040 roundabout and the A1123/A1096 roundabout.",
              "<b>A1123/A1096 Road Layout</b>",
              "A larger scale road layout change would be considered at the A1123/B1040 roundabout and the A1123/A1096 roundabout to help traffic flow in this area. This could consist of a one-way or two-way circular connection via the B1040/A1123/Compass Point. ",
              "<b>A1123 Speed Reduction Measures</b>",
              "Speed reduction measures on A1123 would be considered to help reduce the speeds of vehicles along this corridor. Measures could include public realm enhancements, narrowing of carriageway, installation of sustainable travel measures to make this section of the A1123 more representative of the 30mph speed limit. ",
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmap4.png?alt=media&token=95db9481-a557-4917-b056-2a2d8d717bb2",
          },
          {
            shortHeader: "Option 5",
            header: "Option 5: Sustainable Travel",
            text: [],
            additionalText: [
              "Under option 5, junction priority changes would be made at the Ramsey Road/North Road, North Road/Broad Leas and Globe Place/West Street/East Street junctions to help with the movement of buses through St Ives Town Centre.",
              "A bus gate between the A1123/B1040 roundabout and the A1123/A1096 roundabout would be considered alongside other measures to improve traffic flow and pedestrian and cycle connectivity in this area.  ",
              "This option would include options to work with bus operators to improve and extend the existing Cambridgeshire Guided Bus services and coordinate with work on the future public transport schemes including: ",
              "1.	Along the A1096 and A1307 into Huntingdon Town Centre.",
              "2.	Along the A1123, as with current services, but with additional bus priority where possible.",
              "3.	Along Ramsey Road and Old Ramsey Road to connect to potential new development at RAF Wyton, Warboys and Chatteris.",
              "Option 5 also includes measures identified through previous Study work to improve accessibility of bus stops, and to reduce the delay experienced by buses in St Ives town centre by rationalising on-street parking."
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmaps5.png?alt=media&token=f54abc8d-fd9b-4014-bad4-713e1f77cc3a",
          },
          {
            shortHeader: "Option 6",
            header: "Option 6: Non-Motorised User Options",
            text: [],
            additionalText: [
              "Option 6 includes a variety of options aimed at improving infrastructure provision, safety and route choice for pedestrians, cyclists and equestrians. Specific route considerations include: ",
              "1.	Reconnecting Old Ramsey Road and St Ives Road between Old Hurst and St Ives to provide an off-road connection from north of St Ives.",
              "2.	Connection and upgrade of the Hill Rise footway to the B1040 via Marley Way to connect leisure uses off Hill Rise and also provide a connection to the Nuffield Road industrial estate and to the east of the B1040 to the proposed Gifford’s Farm development.",
              "3.	Localised improvements to the network to the north of the A1123 to improve safety and perceptions of safety, connect existing route and provide new routes along desire lines.",
              "4.	Improvements to the consistency of NMU route along the A1123 through St Ives and between St Ives and Huntingdon. ",
              "5.	An upgrade of The Thicket between St Ives town centre and Houghton, on-road improvements through Houghton and Wyton and improved off-road provision between Huntingdon Road, Wyton, and Old Houghton Road, Huntingdon.",
              "6.	A connection from London Road, south of the River, along the route of the old railway line, to The Avenue, between Godmanchester and Huntingdon. An alternative route has been identified should this not be feasible, via Hemingford Gray and Hemingford Abbots.",
              "7.	Improvements to Low Road to make the route more friendly for pedestrians, cyclists and equestrians to connect through Fenstanton to the new NMU route alongside the A1307 into Cambridge.",
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmap6.png?alt=media&token=83bfeb96-0ac5-4fe5-949a-573b75f0f8fc",
          },
        ],
      },
      timeline: {
        selected: 0,
        time: [
          {
            header: "Spring 2021",
            subheader: "",
            text: "Launch a public engagement and analyse the engagement responses. Undertake additional technical work.",
          },
          {
            header: "Autumn 2021",
            subheader: "Header Needed",
            text: "Report on the findings within a Business Case and options selected to the Combined Authority Board. Any decision being made being dependent on the results of the Engagement exercise.",
          },
          {
            header: "Winter 2021",
            subheader: "Header Needed",
            text: "Commitment for funding to commence the Outline Business Case preliminary design. Further discussions to be held with the Department for Transport to discuss next stages",
          },
        ],
      },
    };
  },

  methods: {
    selectStrategy(index) {
      this.strategies.selected = index;
    },
    selectTimeline(index) {
      this.timeline.selected = index;

      this.progressUpdate(index);
    },
    progressUpdate(index) {
      let progress = document.getElementById("timeline-fill");
      let points = document.querySelectorAll(".timeline-point");

      progress.style.width = `${((index + 1 - 1) / (3 - 1)) * 100}%`;
    },
    openModal() {
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
    },
  },
  computed: {
    ...mapState(["entities", "entityTypes"]),
    ...mapGetters(["user", "allEntityTypes", "allEntities"]),
    pageData() {
      if (this.$route.params.id != undefined) {
        return this.allEntities.find(
          (item) => item.docId == this.$route.params.id
        );
      } else {
        return this.allEntities.find(
          (item) => item.type == this.$route.params.templateName
        );
      }
    },
  },
  mounted() {
    // $(document).ready(function () {
    //   $(".modal").modal();
    // });
  },
  watch: {
    $route(to, from) {
      this.activeInstance = to.params.root;
    },
  },
};
</script>
<style lang="scss" scoped>
.modalOpenButton {
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  right: 20px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 0 5px 4px rgba(29, 50, 92, 0.07);

  i {
    font-size: 25px;
    padding: 6.5px 9.5px;
    color: #4b789c;
  }
}
</style>